<div class="sidebar included">
    <app-sidebar-header [title]="INDRA_getGroupLabel()"></app-sidebar-header>

    <div class="sidebar__body sl--scrollable" #sidebar__body>
        <app-flight-route [flight]="flightRouteInput"></app-flight-route>
        <div class="sidebar__header-image" [style.background-image]="INDRA_printImage()"></div>
        <div class="sidebar-flight-text">
            <h2 class="title-h2">{{'whatsIncludedSidebars.detailsLuggage.titles.includedPassenger' | ibeadmin:'sync'}}</h2>
            <ng-container *ngFor="let statusCode of ancillaryCartService.INDRA_getAllWarnings(flight.idFlight.toString(), ancillaryGroup)">
                <app-notification [style]="'alert'" [close]="true" [icon]="'icons.svg#airport--delays'" [classes]="'alert-sidebar top-gap bottom-gap'" [title]=" INDRA_getGroupLabel() + ' ' + ('whatsIncludedSidebars.general.texts.is' | ibeadmin:'sync')
				 + ' ' + (ancillaryCartService.INDRA_getStatusKey(statusCode)| ibeadmin:'sync') + ' ' + ('whatsIncludedSidebars.general.texts.inThisFlight' | ibeadmin:'sync')">

                </app-notification>
            </ng-container>
            <div *ngFor="let passenger of passengers" class="border sidebar-flight-text">
                <!-- fare related ancillaries for the passenger-->
                <div *ngIf="INDRA_getAncillaryForPassenger(paxFareInfoFeatures, passenger.idPax).length > 0" class="grid no-padding">
                    <div class="col-4 col-tp-4 col-p-12 no-padding">
                        <p class="bold">{{INDRA_printPassengerName(passenger)}}</p>
                    </div>
                    <div class="col-8 col-tp-8 col-p-12">
                        <p class="">
                            <app-svg class="list--checked__icon" svg="sprite.svg#misc--check" aria-hidden="true" [alt]="'Checked icon'">
                            </app-svg>
                            <span class="bold">{{INDRA_getAncillaryForPassenger(paxFareInfoFeatures, passenger.idPax)}}
							</span> {{'whatsIncludedSidebars.detailsLuggage.texts.includedIn' | ibeadmin:'sync'}}
                            <span class="capitalize">{{INDRA_printBrand()}}.</span>
                        </p>
                    </div>
                </div>

                <!-- tier related ancillaries for the passenger-->
                <div *ngIf="INDRA_getAncillaryForPassenger(paxTierAncillary, passenger.idPax).length > 0" class="grid no-padding">
                    <div class="col-4 col-tp-4 col-p-12 no-padding">
                        <p *ngIf="INDRA_getAncillaryForPassenger(paxFareInfoFeatures, passenger.idPax).length == 0" class="bold">{{INDRA_printPassengerName(passenger)}}
                        </p>
                    </div>
                    <div class="col-8 col-tp-8 col-p-12">
                        <p class="">
                            <app-svg class="list--checked__icon" svg="sprite.svg#misc--check" aria-hidden="true" [alt]="'Checked icon'">
                            </app-svg>
                            <span class="bold">{{INDRA_getAncillaryForPassenger(paxTierAncillary, passenger.idPax)}}</span> {{ getBenefitText1SideBar() | ibeadmin:'sync' }} {{ INDRA_getPassengerTierLabel(passenger) }} {{ getBenefitText2SideBar() | ibeadmin:'sync'
                            }}
                        </p>
                    </div>
                </div>

                <!-- fare related priority ancillaries for the passenger -->
                <div *ngIf="INDRA_getAncillaryForPassenger(paxPriorityFareInfoFeatures, passenger.idPax).length > 0" class="grid no-padding">
                    <div class="col-4 col-tp-4 col-p-12 no-padding">
                        <p *ngIf="INDRA_getAncillaryForPassenger(paxTierAncillary, passenger.idPax).length == 0 && INDRA_getAncillaryForPassenger(paxFareInfoFeatures, passenger.idPax).length == 0" class="bold">{{INDRA_printPassengerName(passenger)}}
                        </p>
                    </div>
                    <div class="col-8 col-tp-8 col-p-12">
                        <p class="">
                            <app-svg class="list--checked__icon" svg="sprite.svg#misc--check" aria-hidden="true" [alt]="'Checked icon'">
                            </app-svg>
                            <span class="bold">{{INDRA_getAncillaryForPassenger(paxPriorityFareInfoFeatures, passenger.idPax)}}</span> {{'whatsIncludedSidebars.detailsLuggage.texts.includedIn' | ibeadmin:'sync'}}
                            <span class="capitalize">{{INDRA_printBrand()}}</span>.
                        </p>
                    </div>
                </div>

                <!-- purchased ancillaries for the passenger-->
                <div *ngFor="let item of INDRA_getPurchasedAncillaryForPassenger(passenger.idPax); let i = index;" class="grid no-padding">
                    <div class="col-4 col-tp-4 col-p-12 no-padding">
                        <p *ngIf="i == 0 && INDRA_getAncillaryForPassenger(paxFareInfoFeatures, passenger.idPax).length == 0 && INDRA_getAncillaryForPassenger(paxPriorityFareInfoFeatures, passenger.idPax).length == 0 && INDRA_getAncillaryForPassenger(paxTierAncillary, passenger.idPax).length == 0"
                            class="bold">
                            {{INDRA_printPassengerName(passenger)}}
                        </p>
                    </div>
                    <div class="col-8 col-tp-8 col-p-12">
                        <p class="">
                            <ng-container *ngIf="!item.unconfirmed">
                                <app-svg class="list--checked__icon" svg="sprite.svg#misc--check" aria-hidden="true"></app-svg>
                            </ng-container>
                            <ng-container *ngIf="item.unconfirmed">
                                <app-svg class="list--checked__icon" svg="sprite.svg#status--alert" aria-hidden="true"></app-svg>
                            </ng-container>
                            <span class="bold">{{item.ancillaryDetail}}</span>
                            <span *ngIf="hasLayover">{{INDRA_displaySegmentInfo(item.segmentId)}}</span>
                        </p>
                    </div>
                </div>

                <!-- no ancillaries for the passenger-->
                <div *ngIf="INDRA_getPurchasedAncillaryForPassenger(passenger.idPax).length == 0 && INDRA_getAncillaryForPassenger(paxFareInfoFeatures, passenger.idPax).length == 0 && INDRA_getAncillaryForPassenger(paxPriorityFareInfoFeatures, passenger.idPax).length == 0 && INDRA_getAncillaryForPassenger(paxTierAncillary, passenger.idPax).length == 0"
                    class="grid no-padding">
                    <div class="col-4 col-tp-4 col-p-12 no-padding">
                        <p class="bold">{{INDRA_printPassengerName(passenger)}}</p>
                    </div>
                    <div class="col-8 col-tp-8 col-p-12">
                        <p class="">{{'whatsIncludedSidebars.detailsLuggage.texts.notIncluded' | ibeadmin: 'sync'}}</p>
                    </div>
                </div>
            </div>
        </div>

        <div class="sidebar-flight-text" *ngIf="!isMYB">
            <p>If some of the passengers are Miles&Go Gold members, they have 1 more checked bag included as a perk, free of charge.</p>
            <p>Customers with the TAP Visa Gold and TAP Visa Platinum credit cards also have 1 more checked bag free of charge. Just show the card at the airport.</p>
            <a href="javascript:;" class="link extras-feature__link link--external" aria-label="Open new window">Learn about all of your perks</a>
        </div>

        <div class="sidebar-flight-text">
            <h2 class="title-h2">{{'whatsIncludedSidebars.detailsLuggage.titles.rules' | ibeadmin:'sync'}}</h2>
            <div class="border sidebar-flight-text no-padding">
                <h4 class="bold">{{'whatsIncludedSidebars.detailsLuggage.texts.maxWeight'| ibeadmin:'sync'}}</h4>
                <p class="">{{'whatsIncludedSidebars.detailsLuggage.texts.checkedBaggageWeight' | ibeadmin:'sync'}} : {{getCabinClass() | ibeadmin:'sync'}}</p>
                <p *ngIf="isInfantPassengerIncluded" class="">{{'whatsIncludedSidebars.detailsLuggage.texts.babyAllowance'| ibeadmin:'sync'}} : {{'whatsIncludedSidebars.detailsLuggage.texts.babyAllowanceSpec' | ibeadmin:'sync'}}</p>
            </div>
            <div class="sidebar-flight-text ">
                <h4 class="bold">{{'whatsIncludedSidebars.detailsLuggage.texts.maxDimension'| ibeadmin:'sync'}}</h4>
                <p class="note-top">{{'whatsIncludedSidebars.detailsLuggage.texts.maxDimensionSpecs'| ibeadmin:'sync'}}</p>
                <app-notification *ngIf="isUs" [style]="'alert'" [classes]="'alert-sidebar'" [title]="'whatsIncludedSidebars.detailsLuggage.titles.restrictions' | ibeadmin:'sync'">
                    <div message>{{'whatsIncludedSidebars.detailsLuggage.texts.restrictions' | ibeadmin:'sync'}}</div>
                </app-notification>
                <a (click)="INDRA_gotoURL('externalURLs.aboutLuggage')" href="javascript:;" class="link extras-feature__link link--external note-bottom" [attr.aria-label]="'whatsIncludedSidebars.detailsLuggage.aria.openWindowBaggageRule' | ibeadmin:'sync'">{{'whatsIncludedSidebars.detailsLuggage.texts.allBagRule' | ibeadmin:'sync'}}</a>
            </div>
        </div>
        <div class="sidebar-flight-text" *ngIf="!isBookingView && _hasEdit && !INDRA_checkIfCodeShare() && showAddButton">
            <h2 class="title-h2">{{'whatsIncludedSidebars.detailsLuggage.titles.extraBaggage' | ibeadmin:'sync'}}</h2>
            <p class="muted">{{'whatsIncludedSidebars.detailsLuggage.texts.extraBaggage' | ibeadmin:'sync'}}</p>
            <button class="button " (click)="INDRA_openExtraBagsSidebar()" [attr.aria-label]="'whatsIncludedSidebars.detailsLuggage.aria.openDialogAddExtra' | ibeadmin:'sync'">{{'whatsIncludedSidebars.detailsLuggage.button.addExtraBags' | ibeadmin:'sync'}}</button>
        </div>
        <div class="sidebar-flight-text" *ngIf="!isBookingView && INDRA_showUpgrade()">
            <p class="muted">{{'whatsIncludedSidebars.detailsLuggage.texts.upgrade' | ibeadmin:'sync'}}</p>
            <button class="button " (click)="INDRA_upgradeWithCash()" [attr.aria-label]="'whatsIncludedSidebars.detailsLuggage.aria.openDialogUpgrade' | ibeadmin:'sync'">{{'whatsIncludedSidebars.detailsLuggage.button.upgradeToExecutive' | ibeadmin:'sync'}}</button>
        </div>


        <div class="sidebar-flight-text border">
            <p>
                <a class="link extras-feature__link" aria-label="Close dialog" (click)="INDRA_handleClose()" href="javascript:;" role="button">
					Close this window
				</a>
            </p>
        </div>
    </div>
    <div #sidebar__footer class="sidebar__footer "></div>
</div>